import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import {
  Alert,
  Card,
  List,
  ListItem,
  ContentSectionBlock,
  FormInputText,
  FormInputSelect,
  Button,
  FormInput,
  ButtonContainer
} from 'camino-react'

import AssociatedAnswers from 'Components/Surveys/Questions/Answers/AssociatedAnswers'

const QuestionItem = ({ question, onDelete }) => (
  <ListItem>
    {/*
      Note: the reason this is an 'a' tag is because the original idea was to make question create
      its own CRUD alongside this, therefore you could go directly to the question. However due to time
      constraints, we will leave it only creatable through Surveys for the time being.
    */}
    <a href="javascript:;" className="link">
      {`${question.id} - ${question.question}`}
    </a>
    <button
      type="button"
      style={{ outline: 'none', background: 'transparent', border: 'none' }}
      className="lnr lnr-trash2"
      onClick={(e) => {
        if (confirm('Are you sure you want to remove this question from this survey?')) {
          onDelete()
        }
      }}
    />
  </ListItem>
)

class AssociatedQuestionContent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      unassignedQuestions: [],
      currentQuestions: props.currentQuestions
    }
  }

  componentDidMount () {
    const { questions, currentQuestions } = this.props

    const allUnassignedQuestions = _.filter(questions, ({ id }) => (!_.includes(_.map(currentQuestions, q => (q.id)), id)))
    const unassignedQuestions = _.filter(allUnassignedQuestions, ({ id }) => (!_.includes(_.map(currentQuestions, q => (q.id)), id)))

    this.setState({ unassignedQuestions })
  }

  render () {
    const {
      removeQuestion,
      addQuestion,
      setQuestion,
      associatedQuestionSelections,
      createQuestionSelections,
      addCreateQuestion,
      handleQuestionFieldValue,
      removeQuestionSelection,
      questionTypes,
      onAnswerChange,
      errors
    } = this.props

    const {
      currentQuestions,
      unassignedQuestions
    } = this.state

    const currentListItems = _.map(currentQuestions, (question, index) => (
      <QuestionItem onDelete={() => removeQuestion(question.id)} question={question} key={index} />
    ))

    const questionOptions = _.map(unassignedQuestions, ({ id, question }) => ({ value: id, label: `${id} - ${question}` }))
    const questionSelectors = _.map(associatedQuestionSelections, (questionId, index) => (
      <FormInput>
        <FormInputSelect
          value={_.find(questionOptions, ({ value = {} }) => value === questionId)}
          onValue={value => setQuestion(index, (value || {}))}
          options={questionOptions}
          searchable
          clearable
        />
      </FormInput>
    ))
    const textArea = (index, key) => ({
      value: createQuestionSelections[index] && createQuestionSelections[index][key],
      onValue: value => handleQuestionFieldValue(key, value, index),
      errors: _.some(errors) && errors[index].errors.question
    })

    const fullErrorMessages = index => _.map(errors[index].errors, (error, key) => (`${_.capitalize(key)} ${error}`))

    return (
      <Card allowOverflow padding={false}>
        <ContentSectionBlock>
          {_.isEmpty([...currentQuestions, ...associatedQuestionSelections]) ? (
            <p>
              There are no assigned questions
            </p>
          ) : (
            <List>
              {currentListItems}
            </List>
          )}
          {questionSelectors}
          <ButtonContainer>
            <Button
              onClick={() => addQuestion()}
              outline
              size="compact"
            >
              Add existing question
            </Button>
          </ButtonContainer>
        </ContentSectionBlock>

        <ContentSectionBlock>
          {_.map(createQuestionSelections, (selection, index) => (
            <>
              {_.some(errors) && _.some(errors[index].errors) && (
                <Alert title="Please correct the errors below." type="error">
                  {fullErrorMessages(index)}
                </Alert>
              )}
              <ContentSectionBlock
                title={`Question ${index + 1}`}
                actions={[{
                  text: (
                    <Button
                      onClick={() => removeQuestionSelection(index)}
                      size="compact"
                      color="error"
                    >
                    Remove
                    </Button>
                  )
                }]}
              >
                <FormInput>
                  <FormInputText
                    {...textArea(index, 'question')}
                  />
                </FormInput>
                <FormInput label="Response type">
                  <FormInputSelect
                    value={_.find(questionTypes, ({ value = {} }) => (value === (createQuestionSelections[index] || {}).question_type))}
                    onValue={value => handleQuestionFieldValue('question_type', value, index)}
                    options={questionTypes}
                  />
                </FormInput>
                <AssociatedAnswers
                  {...this.props}
                  question={selection}
                  onAnswerChange={onAnswerChange}
                  questionIndex={index}
                  errors={_.some(errors) && errors[index].errors.answers}
                />
              </ContentSectionBlock>
            </>
          ))}
          <br />
          <ButtonContainer>
            <Button
              onClick={() => addCreateQuestion()}
              outline
              size="compact"
            >
              Create and add question
            </Button>
          </ButtonContainer>
        </ContentSectionBlock>
      </Card>
    )
  }
}

AssociatedQuestionContent.propTypes = {
  survey: PropTypes.shape({}).isRequired,
  currentQuestions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  removeQuestion: PropTypes.func.isRequired,
  addQuestion: PropTypes.func.isRequired,
  setQuestion: PropTypes.func.isRequired,
  associatedQuestionSelections: PropTypes.arrayOf(PropTypes.number).isRequired,
  questions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  createQuestionSelections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  addCreateQuestion: PropTypes.func.isRequired,
  handleQuestionFieldValue: PropTypes.func.isRequired,
  removeQuestionSelection: PropTypes.func.isRequired
}

export default AssociatedQuestionContent
